import { useDeviceToken } from "./hooks/core/useFCMToken";
import { MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import { RouterProvider } from "react-router-dom";
import { Notifications } from "@mantine/notifications";
import { router } from "./routes";
import { theme } from "./config/theme";
import { NavigationHistoryProvider } from "./shared/contexts/NavigationHistoryContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import "@mantine/core/styles.layer.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "mantine-datatable/styles.layer.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CalendarProvider } from "./contexts/CalendarContext";
import { LocalAuthorityProvider } from "./contexts/LocalAuthorityContext";
import { APIProvider } from "@vis.gl/react-google-maps";
import { RouteProvider } from "./contexts/RouteContext";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: Infinity } },
});

const App = () => {
  useDeviceToken();
  const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

  return (
    <MantineProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <DatesProvider>
          <APIProvider apiKey={googleMapsApiKey}>
            <NavigationHistoryProvider>
              <CalendarProvider>
                <LocalAuthorityProvider>
                  <RouteProvider>
                    <ThemeProvider>
                      <Notifications position="top-right" />
                      <RouterProvider router={router} />
                    </ThemeProvider>
                  </RouteProvider>
                </LocalAuthorityProvider>
              </CalendarProvider>
            </NavigationHistoryProvider>
          </APIProvider>
        </DatesProvider>
      </QueryClientProvider>
    </MantineProvider>
  );
};

export default App;
